import { z } from 'zod'
import {
  FacebookPixelSettings,
  defaultFacebookPixelSettings,
} from '../segment-plugin/plugins/custom-facebook-pixel-plugin'

export const CustomFacebookPixels: Record<string, FacebookPixelSettings> = {
  ...(process.env.NEXT_PUBLIC_STREAMING_PIXEL_CUSTOM_FACEBOOK_PIXEL_ENABLED === 'true'
    ? {
        'Streaming Facebook Pixel': {
          ...defaultFacebookPixelSettings,
          allowEcommerceSpecEvents: false,
          pixelId: '915563282734100',
          standardEvents: [
            {
              event: 'Product Viewed - guild',
              standardEventName: 'Product Viewed',
              schema: z.object({
                funnel: z.literal('guild'),
              }),
            },
            {
              event: 'Product Added - guild',
              standardEventName: 'Product Added',
              schema: z.object({
                funnel: z.literal('guild'),
              }),
            },
            {
              event: 'Checkout Started - guild',
              standardEventName: 'Checkout Started',
              schema: z.object({
                funnel: z.literal('guild'),
              }),
            },
            {
              event: 'Order Completed - guild',
              standardEventName: 'Order Completed',
              schema: z.object({
                funnel: z.literal('guild'),
              }),
            },
            {
              event: 'Order Completed - guild',
              standardEventName: 'Subscribe',
              schema: z.object({
                funnel: z.literal('guild'),
              }),
            },
            {
              event: 'Order Completed - gift-guild-add-seats',
              standardEventName: 'Order Completed',
              schema: z.object({
                funnel: z.literal('gift-guild-add-seats'),
              }),
            },
            {
              event: 'Email Captured - guild',
              standardEventName: 'Lead',
            },
            {
              event: 'Guild Signup Account Created',
              standardEventName: 'CompleteRegistration',
            },
            {
              event: 'TVOD Add To Cart',
              standardEventName: 'Product Added',
            },
          ],
        } satisfies FacebookPixelSettings,
      }
    : {}),
  ...(process.env.NEXT_PUBLIC_THEATRICAL_PIXEL_CUSTOM_FACEBOOK_PIXEL_ENABLED === 'true'
    ? {
        'Theatrical Facebook Pixel': {
          ...defaultFacebookPixelSettings,
          pixelId: '723986607933768',
          standardEvents: [
            {
              event: 'Order Completed - theatrical',
              standardEventName: 'Order Completed',
              schema: z.object({
                funnel: z.literal('theatrical'),
              }),
            },
            {
              event: 'Checkout Started - theatrical',
              standardEventName: 'Checkout Started',
              schema: z.object({
                funnel: z.literal('theatrical'),
              }),
            },
            {
              event: 'Product Added - theatrical',
              standardEventName: 'Product Added',
              schema: z.object({
                funnel: z.literal('theatrical'),
              }),
            },
            {
              event: 'Product Viewed - theatrical',
              standardEventName: 'Product Viewed',
              schema: z.object({
                funnel: z.literal('theatrical'),
              }),
            },
            {
              event: 'Product Added - theatrical-pre-sale',
              standardEventName: 'Product Added',
              schema: z.object({
                funnel: z.literal('theatrical-pre-sale'),
              }),
            },
            {
              event: 'Product Viewed - theatrical-pre-sale',
              standardEventName: 'Product Viewed',
              schema: z.object({
                funnel: z.literal('theatrical-pre-sale'),
              }),
            },
            {
              event: 'Email Captured - theatrical',
              standardEventName: 'Lead',
            },
          ],
          onlyTrackLandingPage: false,
          allowEcommerceSpecEvents: false,
        } satisfies FacebookPixelSettings,
      }
    : {}),
  'Sweepstakes Facebook Pixel': {
    ...defaultFacebookPixelSettings,
    pixelId: '569046179454832',
    standardEvents: [
      {
        event: 'Product Added - theatrical-pre-sale',
        standardEventName: 'Product Added',
        schema: z.object({
          funnel: z.literal('theatrical-pre-sale'),
        }),
      },
      {
        event: 'Product Viewed - theatrical-pre-sale',
        standardEventName: 'Product Viewed',
        schema: z.object({
          funnel: z.literal('theatrical-pre-sale'),
        }),
      },
    ],
    onlyTrackLandingPage: true,
    allowEcommerceSpecEvents: false,
    pageViewFilter: (track) => {
      const url = track.proxy('properties.url') as string | undefined
      return !!url && /((pre-sales)|(giveaway))/.test(url)
    },
  },
  'Senior Facebook Pixel': {
    ...defaultFacebookPixelSettings,
    pixelId: '620425533876247',
    standardEvents: [
      {
        event: 'Order Completed - theatrical',
        standardEventName: 'Order Completed',
        schema: z.object({
          funnel: z.literal('theatrical'),
          projectSlug: z.literal('senior'),
        }),
      },
      {
        event: 'Checkout Started - theatrical',
        standardEventName: 'Checkout Started',
        schema: z.object({
          funnel: z.literal('theatrical'),
          projectSlug: z.literal('senior'),
        }),
      },
      {
        event: 'Product Added - theatrical',
        standardEventName: 'Product Added',
        schema: z.object({
          funnel: z.literal('theatrical'),
          projectSlug: z.literal('senior'),
        }),
      },
      {
        event: 'Product Viewed - theatrical',
        standardEventName: 'Product Viewed',
        schema: z.object({
          funnel: z.literal('theatrical'),
          projectSlug: z.literal('senior'),
        }),
      },
      {
        event: 'Product Added - theatrical-pre-sale',
        standardEventName: 'Product Added',
        schema: z.object({
          funnel: z.literal('theatrical-pre-sale'),
          projectSlug: z.literal('senior'),
        }),
      },
      {
        event: 'Product Viewed - theatrical-pre-sale',
        standardEventName: 'Product Viewed',
        schema: z.object({
          funnel: z.literal('theatrical-pre-sale'),
          projectSlug: z.literal('senior'),
        }),
      },
      {
        event: 'Email Captured - theatrical',
        standardEventName: 'Lead',
        schema: z.object({
          projectSlug: z.literal('senior'),
        }),
      },
    ],
    onlyTrackLandingPage: false,
    allowEcommerceSpecEvents: false,
  },
  'Salem Streaming Facebook Pixel': {
    ...defaultFacebookPixelSettings,
    pixelId: '1710474549334251',
    standardEvents: [
      {
        event: 'Order Completed - guild',
        standardEventName: 'Order Completed',
        schema: z.object({
          funnel: z.literal('guild'),
        }),
      },
      {
        event: 'Checkout Started - guild',
        standardEventName: 'Checkout Started',
        schema: z.object({
          funnel: z.literal('guild'),
        }),
      },
      {
        event: 'Product Added - guild',
        standardEventName: 'Product Added',
        schema: z.object({
          funnel: z.literal('guild'),
        }),
      },
      {
        event: 'Product Viewed - guild',
        standardEventName: 'Product Viewed',
        schema: z.object({
          funnel: z.literal('guild'),
        }),
      },
    ],
    allowEcommerceSpecEvents: false,
  },
}
